import { createDiaClient, createSyncEngine, setAccessToken, type DiaClient } from '@dia/db';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from './env';

/**
 * One client and one sync engine for the whole app, made at boot.
 *
 * The session token is swapped in when the guest signs in, rather than a new
 * client being built, so the engine keeps ticking through a sign in.
 */
export const supabase: DiaClient = createDiaClient({
  url: SUPABASE_URL,
  anonKey: SUPABASE_ANON_KEY,
  storageKey: 'dia.guest.auth',
});

export const sync = createSyncEngine(supabase);

export function useSessionToken(token: string | null): void {
  setAccessToken(supabase, token);
}
